import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Onboarding from "./pages/Onboarding";
import Dashboard from "./pages/Dashboard";
import Clients from "./pages/Clients";
import ClientDetail from "./pages/ClientDetail";
import Agenda from "./pages/Agenda";
import Services from "./pages/Services";
import Staff from "./pages/Staff";
import Memberships from "./pages/Memberships";
import Reports from "./pages/Reports";
import Settings from "./pages/Settings";
import CheckIn from "./pages/CheckIn";
import LiveDashboard from "./pages/LiveDashboard";
import Notifications from "./pages/Notifications";
import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster 
          position="top-right" 
          richColors 
          theme="dark"
          toastOptions={{
            style: {
              background: '#0a0a0a',
              border: '1px solid rgba(255,255,255,0.1)',
              color: '#EDEDED',
            },
          }}
        />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/onboarding" element={
            <ProtectedRoute>
              <Onboarding />
            </ProtectedRoute>
          } />
          <Route path="/dashboard" element={
            <ProtectedRoute requireOnboarding>
              <Dashboard />
            </ProtectedRoute>
          } />
          <Route path="/clients" element={
            <ProtectedRoute requireOnboarding>
              <Clients />
            </ProtectedRoute>
          } />
          <Route path="/clients/:id" element={
            <ProtectedRoute requireOnboarding>
              <ClientDetail />
            </ProtectedRoute>
          } />
          <Route path="/agenda" element={
            <ProtectedRoute requireOnboarding>
              <Agenda />
            </ProtectedRoute>
          } />
          <Route path="/services" element={
            <ProtectedRoute requireOnboarding>
              <Services />
            </ProtectedRoute>
          } />
          <Route path="/staff" element={
            <ProtectedRoute requireOnboarding>
              <Staff />
            </ProtectedRoute>
          } />
          <Route path="/memberships" element={
            <ProtectedRoute requireOnboarding>
              <Memberships />
            </ProtectedRoute>
          } />
          <Route path="/reports" element={
            <ProtectedRoute requireOnboarding>
              <Reports />
            </ProtectedRoute>
          } />
          <Route path="/settings" element={
            <ProtectedRoute requireOnboarding>
              <Settings />
            </ProtectedRoute>
          } />
          <Route path="/checkin" element={
            <ProtectedRoute requireOnboarding>
              <CheckIn />
            </ProtectedRoute>
          } />
          <Route path="/live" element={
            <ProtectedRoute requireOnboarding>
              <LiveDashboard />
            </ProtectedRoute>
          } />
          <Route path="/notifications" element={
            <ProtectedRoute requireOnboarding>
              <Notifications />
            </ProtectedRoute>
          } />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
